import { 
    ADD_ACC_ITEM,
    MODIFY_ACC_ITEM,
    REMOVE_ACC_ITEM,
    CLEAR_ACC_QUEUE } from "../actionTypes"

const initial = {
    queue: []
}

const queue = (state = initial, action) => {
    let queue

    switch (action.type) {
        case ADD_ACC_ITEM:
            queue = [...state.queue]
            queue.push({
                item: action.item,
                bulk: 1,
                contains: 1,
                price: action.price,
                vat: 16,
                discount: 0,
            })

            return {
                ...state,
                queue
            }

        case MODIFY_ACC_ITEM:
            queue = [...state.queue]
            queue[action.index] = {
                ...queue[action.index],
                bulk: action.bulk,
                contains: action.contains,
                price: action.price,
                vat: action.vat,
                discount: action.discount,
            }
            
            return {
                ...state,
                queue
            }

        case REMOVE_ACC_ITEM:
            return {
                ...state,
                queue: state.queue.filter((_, i) => i !== action.index)
            }

        case CLEAR_ACC_QUEUE:
            return {
                ...state,
                queue: []
            }

        default:
            return state
    }
}

export default queue